import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"
import Drawer from "@material-ui/core/Drawer"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import containURL from "../components/continueURL"
import BoxTypo from "../components/BoxTypo"
import { createClient } from "microcms-js-sdk"
function Header() {
  const [isOpen, setOpen] = useState(false)
  const tempNewsArray = []

  const client = createClient({
    serviceDomain: "unfilter",
    apiKey: "d573439a90ee41bbb02f75e44b1bd5a92908",
  })
  const [dlNews, setNews] = useState()

  useEffect(() => {
    client
      .get({
        endpoint: "header",
        queries: { limit: 10 },
        useGlobalDraftKey: false, // This is an option if your have set the globalDraftKey. Default value true.
      })
      .then(res => {
        res.contents.map(c => {
          const tempObj = {
            title: c.title,
            link: c?.link,
          }
          tempNewsArray.push(tempObj)
        })
        console.log("header", tempNewsArray)
        setNews(() => tempNewsArray)
      })
  }, [setNews])

  const data = useStaticQuery(graphql`
    query {
      logo_pc: file(relativePath: { eq: "pc_header_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logo_sp: file(relativePath: { eq: "sp_header_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_bar_sp: file(relativePath: { eq: "menu_bar.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_isClose_sp: file(relativePath: { eq: "heder_isClose_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      footer_line: file(relativePath: { eq: "footer_line.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      footer_instagram: file(relativePath: { eq: "footer_instagram.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_open_button: file(relativePath: { eq: "menu_open_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_close_button: file(relativePath: { eq: "menu_close_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      header_logo: file(relativePath: { eq: "header_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_right_image: file(relativePath: { eq: "up6_20211115.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      top_unfilter_logo: file(relativePath: { eq: "introduction_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Box>
        <Hidden mdDown>
          <Box
            zIndex="9999"
            style={
              isOpen == true ? { display: "none" } : { position: "absolute" }
            }
          >
            <Box
              style={{
                width: "100%",
                position: "fixed",
                top: "0px",
                left: "0%",
              }}
            >
              <Box width={"100%"} bgcolor={"#f5f5f5"} mb={3}>
                {dlNews?.map((c, i) => {
                  return (
                    <Link
                      to={c.link}
                      width="100%"
                      textAlign="cneter"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: c?.link ? "underline #999" : "none",
                      }}
                    >
                      <BoxTypo
                        textAlign="center"
                        fs={["12px"]}
                        ls={["2px"]}
                        lh={["200%"]}
                        py={2}
                        m={"auto"}
                      >
                        {c.title}
                      </BoxTypo>
                    </Link>
                  )
                })}
              </Box>
              <Box
                display="flex"
                justifyContent={"space-between"}
                width={"90%"}
                m={"auto"}
              >
                <Box>
                  <Button onClick={() => setOpen(!isOpen)}>
                    <Box width="34px" height="11px">
                      <Img fluid={data.menu_bar_sp.childImageSharp.fluid} />
                    </Box>
                  </Button>
                </Box>
                <Box width="159px" height="27px">
                  <Img fluid={data.top_unfilter_logo.childImageSharp.fluid} />
                </Box>
              </Box>
            </Box>
          </Box>
          <Drawer
            anchor="left"
            open={isOpen}
            transitionDuration={1000}
            onClose={() => {
              setOpen(false)
            }}
          >
            <Box width="100vw" height="100%" bgcolor="#F2F2F2">
              <Grid
                container
                direction="row"
                justify="space-around"
                alignItems="stretch"
                style={{ height: "100%" }}
              >
                <Grid item xs={2}>
                  {/* <Button onClick={() => setOpen(!isOpen)}> */}
                  <Box
                    style={{
                      position: "fixed",
                      top: "80px",
                      bottom: "0",
                      left: "3%",
                    }}
                  >
                    <Button onClick={() => setOpen(!isOpen)}>
                      <Box width="22.3px" height="22.3px">
                        <Img
                          fluid={data.menu_isClose_sp.childImageSharp.fluid}
                        />
                      </Box>
                    </Button>
                  </Box>
                  {/* <Box
                      width="60px"
                      height="78vh"
                      style={{
                        position: "fixed",
                        top: "10%",
                        bottom: "0",
                        left: "3%",
                      }}
                    >
                      <Img
                        fluid={data.menu_close_button.childImageSharp.fluid}
                      />
                    </Box>
                  </Button> */}
                </Grid>
                <Grid
                  item
                  xs={5}
                  style={{ height: "80%", maxHeight: "600px", margin: "auto" }}
                >
                  <Grid container style={{ height: "100%" }}>
                    <Grid
                      container
                      direction="column"
                      justify="space-around"
                      alignItems="flex-start"
                      style={{ width: "100%", height: "100%", margin: "auto" }}
                    >
                      <Grid item>
                        <Link to={"/"} onClick={() => setOpen(!isOpen)}>
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            HOME
                          </WrapTypo>
                          <WrapTypo fs="14px">トップページ</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link to={"/product"} onClick={() => setOpen(!isOpen)}>
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            PRODUCTS
                          </WrapTypo>
                          <WrapTypo fs="14px">商品詳細</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          to={containURL(
                            "https://unfilter.co.jp/shop/pages/gift"
                          )}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            GIFT
                          </WrapTypo>
                          <WrapTypo fs="14px">ギフト</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          to={containURL(
                            "https://unfilter.co.jp/shop/customer"
                          )}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            LOGIN
                          </WrapTypo>
                          <WrapTypo fs="14px">マイページ</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link to={"/faq"} onClick={() => setOpen(!isOpen)}>
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            FAQ
                          </WrapTypo>
                          <WrapTypo fs="14px">よくある質問</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          to={containURL(
                            "https://unfilter.co.jp/shop/contact/draft"
                          )}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            CONTACT
                          </WrapTypo>
                          <WrapTypo fs="14px">お問い合わせ</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          to={containURL(
                            "https://unfilter.co.jp/shop/pages/friend_campaign"
                          )}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <WrapTypo isHunter={true} fs="24px" lh="100%">
                            REFERRAL
                          </WrapTypo>
                          <WrapTypo fs="14px">お友達紹介制度</WrapTypo>
                        </Link>
                      </Grid>
                      <Grid item lh="100%" style={{ width: "60%" }}>
                        <Grid container>
                          <Grid item xs={2}>
                            <Link
                              to={containURL(
                                "https://instagram.com/unfilter_official?igshid=1v8i9bx1ok826"
                              )}
                              onClick={() => setOpen(!isOpen)}
                            >
                              <Box width="36px">
                                <Img
                                  fluid={
                                    data.footer_instagram.childImageSharp.fluid
                                  }
                                />
                              </Box>
                            </Link>
                          </Grid>
                          <Grid
                            item
                            xs={10}
                            style={{ minWidth: "210px", maxWidth: "290px" }}
                          >
                            <Box border="1px solid #C4C4C4">
                              <Link
                                to={containURL("https://lin.ee/vNCiMwP")}
                                onClick={() => setOpen(!isOpen)}
                              >
                                <Grid container>
                                  <Grid item xs={2}>
                                    <Box width="36px">
                                      <Img
                                        fluid={
                                          data.footer_line.childImageSharp.fluid
                                        }
                                      />
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={10}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Grid
                                      container
                                      direction="row"
                                      justify="center"
                                      alignItems="center"
                                      style={{ width: "100%", height: "100%" }}
                                    >
                                      <Grid item>
                                        <WrapTypo fs="12px">
                                          LINE@だけの特別な情報を受け取る
                                        </WrapTypo>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Link>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={2}
                  style={{ width: "100%", height: "60%", margin: "auto" }}
                >
                  <Box width="180px" height="180px">
                    <Img fluid={data.header_logo.childImageSharp.fluid} />
                  </Box>
                </Grid>
                <Grid item xs={3} style={{ width: "100%", height: "100%" }}>
                  <Box>
                    <Img
                      style={{ height: "100vh" }}
                      fluid={data.menu_right_image.childImageSharp.fluid}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Drawer>
        </Hidden>
        {/* sp_header */}
        <Hidden lgUp>
          <Box position="fixed" bgcolor="#fff" width="100%" zIndex="100">
            <Box width={"100%"} bgcolor={"#f5f5f5"} mb={1}>
              {dlNews?.map((c, i) => {
                return (
                  <Link
                    to={c?.link}
                    width="100%"
                    textAlign="cneter"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: c?.link ? "underline #999" : "none",
                    }}
                  >
                    <BoxTypo
                      textAlign="center"
                      fs={["12px"]}
                      ls={["2px"]}
                      lh={["200%"]}
                      py={1}
                      m={"auto"}
                    >
                      {c.title}
                    </BoxTypo>
                  </Link>
                )
              })}
            </Box>
            <Box m="auto" height="50px">
              {/* 69px */}
              <Grid container alignItems="center" style={{ height: "100%" }}>
                <Grid item xs={2}>
                  <Button onClick={() => setOpen(!isOpen)}>
                    <Box width="30.72px" height="8.95px" margin="auto">
                      <Img fluid={data.menu_bar_sp.childImageSharp.fluid} />
                    </Box>
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  <Box width="107.32px" height="18.21px" margin="auto">
                    <Img fluid={data.logo_sp.childImageSharp.fluid} />
                  </Box>
                </Grid>
                <Grid item xs={2}>
                  <></>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Drawer
            anchor="left"
            transitionDuration={1000}
            open={isOpen}
            onClose={() => {
              setOpen(false)
            }}
          >
            <Box width="100vw" height="100%" bgcolor="#F4F4F4">
              <Box height="69px" bgcolor="#ffffff">
                <Grid container alignItems="center" style={{ height: "100%" }}>
                  <Grid item xs={2}>
                    <Button onClick={() => setOpen(!isOpen)}>
                      <Box width="22.31px" margin="auto">
                        <Img
                          fluid={data.menu_isClose_sp.childImageSharp.fluid}
                        />
                      </Box>
                    </Button>
                  </Grid>
                  <Grid item xs={8}>
                    <></>
                  </Grid>
                  <Grid item xs={2}>
                    <></>
                  </Grid>
                </Grid>
              </Box>
              <Box
                width="100%"
                textAlign="center"
                justify="center"
                height="70%"
                mt="5%"
              >
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  style={{ height: "100%" }}
                >
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item xs={12} style={{ marginBottom: "15px" }}>
                      <Link to={"/"} onClick={() => setOpen(!isOpen)}>
                        <WrapTypo isHunter={true} variant="h5">
                          HOME
                        </WrapTypo>
                      </Link>
                      <WrapTypo fs="10px">トップページ</WrapTypo>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "15px" }}>
                      <Link to={"/product"} onClick={() => setOpen(!isOpen)}>
                        <WrapTypo isHunter={true} variant="h5">
                          PRODUCTS
                        </WrapTypo>
                        <WrapTypo fs="10px">商品詳細</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "15px" }}>
                      <Link
                        to={containURL(
                          "https://unfilter.co.jp/shop/pages/gift"
                        )}
                        onClick={() => setOpen(!isOpen)}
                      >
                        <WrapTypo isHunter={true} variant="h5">
                          GIFT
                        </WrapTypo>
                        <WrapTypo fs="10px">ギフト</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "15px" }}>
                      <Link
                        to={containURL(
                          "https://unfilter.co.jp/shop/pages/gift"
                        )}
                        onClick={() => setOpen(!isOpen)}
                      >
                        <WrapTypo isHunter={true} variant="h5">
                          LOGIN
                        </WrapTypo>
                        <WrapTypo fs="10px">マイページ</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "15px" }}>
                      <Link to={"/faq"} onClick={() => setOpen(!isOpen)}>
                        <WrapTypo isHunter={true} variant="h5">
                          FAQ
                        </WrapTypo>
                        <WrapTypo fs="10px">よくある質問</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "19px" }}>
                      <Link
                        to={containURL(
                          "https://unfilter.co.jp/shop/contact/draft"
                        )}
                        onClick={() => setOpen(!isOpen)}
                      >
                        <WrapTypo isHunter={true} variant="h5">
                          CONTACT
                        </WrapTypo>
                        <WrapTypo fs="10px">お問い合わせ</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "19px" }}>
                      <Link
                        to={containURL(
                          "https://unfilter.co.jp/shop/pages/friend_campaign"
                        )}
                        onClick={() => setOpen(!isOpen)}
                      >
                        <WrapTypo isHunter={true} variant="h5">
                          REFERRAL
                        </WrapTypo>
                        <WrapTypo fs="10px">お友達紹介制度</WrapTypo>
                      </Link>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                      >
                        <Link
                          to={containURL("https://lin.ee/vNCiMwP")}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <Box width="29px" mr={2}>
                            <Img
                              fluid={data.footer_line.childImageSharp.fluid}
                            />
                          </Box>
                        </Link>
                        <Link
                          to={containURL(
                            "https://instagram.com/unfilter_official?igshid=1v8i9bx1ok826"
                          )}
                          onClick={() => setOpen(!isOpen)}
                        >
                          <Box width="29px">
                            <Img
                              fluid={
                                data.footer_instagram.childImageSharp.fluid
                              }
                            />
                          </Box>
                        </Link>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Drawer>
        </Hidden>
        {/* sp_header */}
      </Box>
    </>
  )
}

export default Header
